import { find, sortBy, uniqBy } from "lodash";
import { useMemo } from "react";
import { useAllBook } from "store/books/selectors";
import { useClassActivities } from "store/classActivities/selectors";
import { useClassQuizzes } from "store/classQuizzes/selectors";
import { useClassGameActivity } from "store/one_game/selectors";
import { useResources } from "store/resources/selectors";
import { articleLevelCover, GrammarDrillCover, SoyHistoriasNew, SoyStoryImg } from "utils/assets/images";
import { imageFetchDinamic, imageFetchFromPodcast } from "utils/lib/ebookHelper";



export const usePageCover = ({ assignmentData, grammer_drill = false,  }) => {
  const bookAllList = useAllBook();
  const resources = useResources();
  const booksAllList = useAllBook();
  const classActivities = useClassActivities();
  const classQuizzes = useClassQuizzes();
  const {class_game_activity} = useClassGameActivity();
  const all_activities = useMemo(() => {
    return [...classActivities, ...classQuizzes, ...class_game_activity];
  }, [classActivities, classQuizzes, class_game_activity]);

  const findBookByBookId = useMemo(() => {
    if (!assignmentData) return null;
    const sortById = sortBy(bookAllList, 'id');
    const book = find(sortById, { id: assignmentData?.chapter });
    return book;
  }, [bookAllList, assignmentData])

  const pageCover = useMemo(() => {
    try {
      if (!assignmentData) return null;
      const findActivity = find(all_activities, { activityId: assignmentData?.data?.id || assignmentData?.id });
      if(findActivity?.meta_data?.book_info?.page_cover_url) {
        return findActivity?.meta_data?.book_info?.page_cover_url;
      }

      
      let _chapter = assignmentData?.chapter ? assignmentData?.chapter : assignmentData?.data?.chapter;
      let _page = assignmentData?.page ? assignmentData?.page : assignmentData?.data?.page;
      if (!_chapter) {
        _chapter = assignmentData?.book_id;
      }
      if (!_page) {
        _page = assignmentData?.page_id;
      }
      const isWorksheet = assignmentData?.type === 'worksheet' || assignmentData?.assignmentType === 'worksheet' || assignmentData?.data?.assignmentType === 'worksheet';
      const is_soy_story = ((typeof assignmentData.storyInstruction == "string" && assignmentData.storyInstruction.length > 0) || (assignmentData?.data && typeof assignmentData?.data.storyInstruction == "string" && assignmentData?.data.storyInstruction.length > 0))
      const is_article_level = ((typeof assignmentData.article_level_id == "string" && assignmentData.article_level_id.length > 0) || (assignmentData?.data && typeof assignmentData?.data.article_level_id == "string" && assignmentData?.data.article_level_id.length > 0))


      const is_engage = assignmentData?.config_assignment?.isFrom === 'engagement';
      if (is_engage) {
        const allEngage = findBookByBookId?.engage;
        const engage = find(allEngage, { id: assignmentData?.config_assignment?.engage_id });
        const findImageData = find(engage?.imageData, { id: assignmentData?.config_assignment?.sequence_order });
        return findImageData?.resource;
      }
      else if (isWorksheet) {
        return GrammarDrillCover || imageFetchDinamic(_chapter, _page, booksAllList)?.resource ;
      }
      else if (is_soy_story) {
        return SoyHistoriasNew;
      }
      else if (is_article_level) {
        return articleLevelCover;
      }
      else {
        let url = imageFetchFromPodcast(_chapter, resources) ? imageFetchFromPodcast(_chapter, resources) : imageFetchDinamic(_chapter, _page, booksAllList)?.resource
        return url;
      }
    } catch (error) {
      return null;
    }
  }, [assignmentData, findBookByBookId, resources, booksAllList]);

  return pageCover;
};
